import Table from "../components/tourist-industries/Table";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";

/* 
旅行業登録者定義照会・更新画面
 */
const TouristIndustries = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.MASTER_EDIT);
  return (
    <SpaceBetween size="l">
      <Table />
    </SpaceBetween>
  );
};

export default TouristIndustries;
